import { createContext, useContext } from 'react';
import { GqlDocumentsCommandActions, GqlDocumentsQueryActions } from '../gql';
import { DocumentsCommandActions, DocumentsQueryActions } from './../../domain';

type DocumentsActionContextT = {
  documentQueryActions: DocumentsQueryActions;
  documentsCommandActions: DocumentsCommandActions;
};

export const documentsDefaultValue: DocumentsActionContextT = {
  documentsCommandActions: GqlDocumentsCommandActions,
  documentQueryActions: GqlDocumentsQueryActions,
};

export const documentActionsContext = createContext<DocumentsActionContextT>(documentsDefaultValue);

export const useDocumentationActions = (): DocumentsActionContextT => useContext(documentActionsContext);
